import { I18nString } from '@models/i18n/i18n-string';
import { AdminUser } from './admin-user';
import { BinaryFile } from './binary-file';
import { I18nStringMap } from './i18n/i18n-string-map';
import { User } from './user';
import {OnepageField} from './onepage-template-field';
import { OnepageTemplate } from './onepage-template';
import { DeploymentProductInfo } from './deployment-product-info';

export type TemplateType = 'USER' | 'SYSTEM';


export class Deployment {

    id: string;
    url: string;
    createdAt: string;
    deployVersion: number;
    description: string;
    onepageTemplateCode: string;
    onepageTemplateId: string;
    merCode: string;
    deployedWithNewUrl: boolean;
    template: OnepageTemplate;
    startFrom: Date;
    endTo: Date;

    endToDateValue: number;
    startFromDateValue: number;
    quota: number;
    useProductQuota: boolean;
    outOfDate: boolean;

    status: string;

    publishLanguage: string;

    
    originalQuota: number = -1;
    quotaLeft: number;

    
    productInfos: DeploymentProductInfo[];

    constructor() {
        
        // this.templateFileName = new I18nStringMap();
        // let en = new I18nString();
        // let zh_tw = new I18nString();
        // let zh_cn = new I18nString();
        // en.locale = 'en';
        // zh_tw.locale = 'zh_TW';
        // zh_cn.locale = 'zh_CN';

        // this.templateFileName.i18nStrings = [];
        // this.templateFileName.i18nStrings.push(en);
        // this.templateFileName.i18nStrings.push(zh_tw);
        // this.templateFileName.i18nStrings.push(zh_cn);
    }

    static search(term: string, item: OnepageTemplate) {
        term = term.toLocaleLowerCase();
        return true;//item.templateFileName.i18nStrings.findIndex(name => name.value.toLocaleLowerCase().indexOf(term) > -1) > -1;
        // return  item.templateFileName.toLocaleLowerCase().indexOf(term) > -1;
    }
}


export class PublishSearchingCriteria{
    description: string;   
    templateCode: string;
    createdAt: string;
    deployVersion: number;
    status: string;
}
